import BaseTimePicker from "./BaseTimePicker.vue";

export default BaseTimePicker;
